var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPressureError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5.33333,
    fill: "#E4372C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7584 7.93103V7H20.8964V7.93103C20.9158 9.57779 21.3859 11.1878 22.2557 12.5862C22.9887 13.7912 23.3778 15.1739 23.3805 16.5844C23.3832 17.9948 22.9996 19.3791 22.2712 20.5869L22.2371 20.6428H9.00395L8.96981 20.5869C8.24174 19.379 7.85829 17.9948 7.86102 16.5844C7.86376 15.174 8.25258 13.7913 8.98533 12.5862C9.85584 11.1881 10.326 9.5779 10.3446 7.93103V7H8.48257V7.93103C8.46725 9.24149 8.09145 10.5224 7.39636 11.6334C6.51011 13.09 6.0285 14.7567 6.00123 16.4615C5.97395 18.1663 6.40199 19.8475 7.24119 21.3317V25H9.10326V22.5172H12.2067V25H14.0688V22.5172H17.1722V25H19.0343V22.5172H22.1377V25H23.9998V21.3317C24.839 19.8475 25.267 18.1663 25.2398 16.4615C25.2125 14.7567 24.7309 13.09 23.8446 11.6334C23.1504 10.522 22.7747 9.24134 22.7584 7.93103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5515 8.24146H14.6895V14.4484H16.5515V8.24146Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6205 18.4828C16.1347 18.4828 16.5515 18.066 16.5515 17.5518C16.5515 17.0376 16.1347 16.6207 15.6205 16.6207C15.1063 16.6207 14.6895 17.0376 14.6895 17.5518C14.6895 18.066 15.1063 18.4828 15.6205 18.4828Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPressureError);
export default __webpack_public_path__ + "static/media/icon_pressure_error.8be8e63596f4eff6369574b2a7bf76a1.svg";
export { ForwardRef as ReactComponent };